import Container = PIXI.Container;
import { TweenMax } from 'gsap';
import { getGameSize, IGameSizeInfo } from '../../../Config/Levels';
import Core from '../../../Core/Core';
import { createOutlineText } from '../../../Utils/Utils';
import { ScreenBlur } from '../../Shared/ScreenBlur';

// Do we have a class for video ad loading? Perhaps we can use the same but change the string?...or use this for that one
/**
 * loading screen shown when the player clicks on the invite button on the socialhubpopup
 */
export class LoadingSocialInteraction extends Container {
    private sBlur: ScreenBlur;
    private loadT: PIXI.Text;
    constructor() {
        super();

        const sBlur = new ScreenBlur();
        sBlur.alpha = 0;
        sBlur.interactive = true;
        const loadT = createOutlineText(
            Core.local.getText('loading'),
            new PIXI.Rectangle(
                getGameSize().gameWidth / 2,
                getGameSize().gameHeight / 2,
                getGameSize().gameWidth * 0.7,
                getGameSize().gameHeight * 0.4
            ),
            'Baloo',
            60,
            60
        );
        loadT.alpha = 0;

        //@ts-ignore
        this.addChild(sBlur, loadT);
        this.sBlur = sBlur;
        this.loadT = loadT;
    }

    public async tweenIn() {
        TweenMax.to([this.sBlur, this.loadT], 0.2, { alpha: 1 });
    }

    public async tweenOut() {
        TweenMax.to([this.sBlur, this.loadT], 0.2, {
            alpha: 0,
            onComplete: () => {
                this.destroy();
            },
        });
        return;
    }
    public resize(sizeInfo: IGameSizeInfo) {
        if (this.sBlur) {
            this.sBlur.resize(sizeInfo);
        }
    }
}
